import get from 'lodash/get';

import entity from './entity';

const { getAllFromState, getByIdFromState, getByIdsFromState, getByPropertiesFromState } = entity.getState();

const getProfileByKey = key => state => get(state, `entities.profiles.data[${key}]`);

const state = {
  getAllProfiles: getAllFromState,
  getProfileById: getByIdFromState,
  getProfilesByIds: getByIdsFromState,
  getProfilesByPropertiesFromState: getByPropertiesFromState,
  getProfileByKey,
};

export const { getAllProfiles, getProfileById, getProfilesByIds, getProfilesByPropertiesFromState } = state;

export default state;

export { getProfileByKey };
